import { render } from "./IconNotification2.vue?vue&type=template&id=1d352c22"
import script from "./IconNotification2.vue?vue&type=script&lang=js"
export * from "./IconNotification2.vue?vue&type=script&lang=js"
script.render = render

export default script